<template>
  <div
    class="ranking relative pl-10 pr-4 after:absolute after:bottom-0 after:left-0 after:h-9 after:w-10"
  >
    <div class="ranking__inner relative pb-9 pt-9">
      <div
        class="ranking__inner2 before:content relative -ml-8 -mr-2 border-l-4 border-r-4 border-[#63472f] p-[0_20px_16px] before:absolute before:bottom-0 before:left-0 before:top-0 before:block before:w-1 before:bg-[#d19c5e] after:absolute after:bottom-0 after:right-0 after:top-0 after:block after:w-1 after:bg-[#d19c5e]"
        :class="mode === MODE.normal ? ['bg-[#ffe6ca]'] : ['bg-[#ffd9ae]']"
      >
        <div class="flex flex-col gap-y-2">
          <h2 class="flex justify-center">
            <Img
              src="/images/ranking/ranking/ranking_ttl_normal.svg"
              alt="全国ランキング"
              :width="320"
            />
          </h2>
          <template v-if="rankingTop.length > 0">
            <dl
              v-for="(userRank, i) in upperUserRank"
              :key="userRank?.name ?? '' + userRank?.rank + userRank?.score"
              class="flex gap-x-3 leading-[1.4]"
              :class="[
                i === 0 ? ['text-[22px]'] : ['text-lg'],
                i === myIndexNumber ? ['font-bold'] : ['font-normal'],
              ]"
            >
              <dt
                class="min-w-[40px] text-right"
                :class="
                  i !== 0 && upperUserRank[i - 1]?.rank === userRank?.rank
                    ? ['invisible']
                    : ['']
                "
              >
                {{ userRank?.rank }}位
              </dt>
              <dd class="flex-1">{{ userRank?.name }}さん</dd>
              <dd>{{ userRank?.score }}点</dd>
            </dl>
            <template
              v-if="
                rankingUserId !== null &&
                rankingTop.length > 8 &&
                myIndexNumber >= 7
              "
            >
              <div class="text-center">
                <span class="inline-block -rotate-90">…</span>
              </div>
              <dl
                v-if="!!rankingUserId?.upper"
                class="flex gap-x-3 text-lg leading-[1.4]"
                :class="
                  rankingUserId.user?.rank === rankingUserId.upper.rank
                    ? ['invisible']
                    : ['']
                "
              >
                <dt class="min-w-[40px] text-right">
                  {{ rankingUserId.upper.rank }} 位
                </dt>
                <dd class="flex-1">{{ rankingUserId.upper.name }}さん</dd>
                <dd>{{ rankingUserId.upper.score }}点</dd>
              </dl>
              <dl
                v-if="!!rankingUserId?.user && !!rankingUserId.upper"
                class="flex gap-x-3 text-lg font-bold leading-[1.4]"
                :class="
                  rankingUserId.upper.rank === rankingUserId.user.rank
                    ? ['invisible']
                    : ['']
                "
              >
                <dt class="min-w-[40px] text-right">
                  {{ rankingUserId.user.rank }} 位
                </dt>
                <dd class="flex-1">{{ rankingUserId.user.name }}さん</dd>
                <dd>{{ rankingUserId.user.score }}点</dd>
              </dl>
              <dl
                v-if="!!rankingUserId?.lower"
                class="flex gap-x-3 text-lg leading-[1.4]"
              >
                <dt class="min-w-[40px] text-right">
                  {{ rankingUserId.lower.rank }} 位
                </dt>
                <dd class="flex-1">{{ rankingUserId.lower.name }}さん</dd>
                <dd>{{ rankingUserId.lower.score }}点</dd>
              </dl>
            </template>
          </template>
          <p v-else class="text-center">
            まだ今週の全国ランキングは<br />作成されていません。<br />ゲームに挑戦してランクインを目指そう！
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type {
  GetRankingUserId200,
  ModeParameter,
  UserRank,
} from '~/api/generated/model';
import { MODE } from '~/constants';

interface Props {
  mode: ModeParameter;
  rankingTop: UserRank[];
  rankingUserId: GetRankingUserId200 | null;
}

const props = defineProps<Props>();

/**
 * 自分の順番
 */
const myIndexNumber = computed<number>(() => {
  if (!props.rankingUserId || !props.rankingUserId.user) return 0;
  return props.rankingUserId.user.rank - 1;
});

/**
 * 上位の配列
 */
const upperUserRank = computed<UserRank[]>(() => {
  if (myIndexNumber.value === 5) return props.rankingTop.slice(0, 7);
  if (myIndexNumber.value === 6) return props.rankingTop.slice(0, 8);
  return props.rankingTop.slice(0, 5);
});
</script>

<style scoped>
.ranking {
  background-image: url('/images/ranking/ranking/ranking_bg_normal_03.svg'),
    url('/images/ranking/ranking/ranking_bg_normal_04.svg'),
    url('/images/ranking/ranking/ranking_bg_normal_06.svg');
  background-repeat: no-repeat, no-repeat, no-repeat;
  background-position:
    top left,
    top right,
    bottom right;
}
.ranking::after {
  background-image: url('/images/ranking/ranking/ranking_bg_normal_05.svg');
  background-repeat: no-repeat;
  background-position: top left;
  transform: rotate(180deg) scale(-1, 1);
}
.ranking__inner {
  background-image: url('/images/ranking/ranking/ranking_bg_normal_01.svg'),
    url('/images/ranking/ranking/ranking_bg_normal_02.svg');
  background-repeat: repeat-x, repeat-x;
  background-position:
    top left,
    bottom left;
}
</style>
